import { useMemo } from "react";
import cx from "classix";

export const LoginFeedback = ({ status, className }) => {
  const message = useMemo(
    () => ({
      sending_link: "Validando...",
      check_email: "Estamos OK. Por favor revisa tu correo y haz click en el link para el acceso :)",
    }),
    []
  );

  return <div className={cx("LoginFeedback", className)}>{message[status]}</div>;
};
